import Quill from "quill";
import "quill-mention/autoregister";
import { getCustomFormula } from "../utils";

const MentionBlot = Quill.import("blots/mention");

class StyledMentionBlot extends MentionBlot {
  static render(data) {
    const element = document.createElement('span');
    element.classList = 'bg-brand-tertiary-200 p-1 mx-1 rounded'
    element.innerText = data.name;
    return element;
  }
}
StyledMentionBlot.blotName = "styled-mention";

Quill.register(StyledMentionBlot);
let quillInstance = null;

const initMentions = function (mentions, prefilledFormula='', id="metric_formula") {
    quillInstance = new Quill(`#${id}`, {
        placeholder:'Start by @ to choose your metrics',
        theme: 'snow',
        formats:'',
        modules: {
            mention: {
                allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                dataAttributes: ['id', 'value', 'name',],
                blotName: 'styled-mention',
                spaceAfterInsert: true,
                mentionListClass: 'relative bg-white rounded-md shadow-lg z-50 max-h-64 overflow-auto',
                showDenotationChar: false,
                mentionDenotationChars: ["@"],
                renderItem: (item, searchTerm) => {
                    const nameSpan = document.createElement('span');
                    nameSpan.classList.add('mention-name','font-medium');
                    // textContent, never innerHTML: a metric name is typed by any member, and an
                    // element built from it would run its handlers as soon as the list renders.
                    nameSpan.textContent = item.name;

                    const sourceIdSpan = document.createElement('span');
                    sourceIdSpan.classList.add('mention-source-id','text-xs','block', 'opacity-60');
                    sourceIdSpan.textContent = item.source_id;

                    const container = document.createElement('div');
                    container.appendChild(nameSpan);
                    container.appendChild(document.createElement('br'));
                    container.appendChild(sourceIdSpan);

                    return container;
                  },

                source: function (searchTerm, renderItem, mentionChar) {
                    let values;
                    const originalMentions = [...mentions];

                    if (mentionChar === "@") {
                        values = originalMentions.slice(0,10);

                        if (searchTerm.length === 0) {
                            for (let i = 0; i < values.length; i++)
                                renderItem(values, searchTerm)
                        } else {
                            const matches = [];
                            for (let i = 0; i < originalMentions.length; i++)
                                if (
                                    ~originalMentions[i].name
                                        .toLowerCase()
                                        .indexOf(searchTerm.toLowerCase())
                                )
                                    matches.push(originalMentions[i]);
                            for (let i = 0; i < matches.length; i++)
                                renderItem(matches.slice(0,10),searchTerm)
                        }
                    }
                },
            },
        },
    });

    // Set labelledby attribute for accessibility
  const labelElement = document.getElementById(`label-for-${id}`);
  if (labelElement) {
    quillInstance.root.setAttribute('aria-labelledby', labelElement.id);
  }
  // Set describedby attribute for accessibility
  const descriptionElement = document.getElementById(`description-for-${id}`);
  if (descriptionElement) {
    quillInstance.root.setAttribute('aria-describedby', descriptionElement.id);
  }
  // Set error message for accessibility
    const errorElement = document.getElementById(`errmsg_${id}`);
    if (errorElement) {
        const existingDescribedBy = quillInstance.root.getAttribute('aria-describedby') || '';
        // Append the error element's ID to the existing describedby attribute
        quillInstance.root.setAttribute('aria-describedby', `${existingDescribedBy} ${errorElement.id}`.trim());
    }

      // Insert the prefilled formula into the editor
  if (prefilledFormula) {
    quillInstance.clipboard.dangerouslyPasteHTML(0, prefilledFormula);
  }
    quillInstance.on('text-change', function (delta, oldDelta, source) {
        let formula = getCustomFormula(quillInstance.root.innerHTML);
        window.Livewire.dispatch('addCustomFormulaInput', { formula: formula });
    });

};

function insertMetric(metric) {
    // Built with DOM APIs, not an HTML string: a quote in a metric name would otherwise rewrite the
    // mention's data attributes, and Quill reads the inserted metric back from those attributes.
    const mention = document.createElement('span');
    mention.className = 'mention';
    mention.dataset.index = '0';
    mention.dataset.denotationChar = '';
    mention.dataset.id = metric.id;
    mention.dataset.name = metric.name;
    mention.dataset.value = metric.value;

    const content = document.createElement('span');
    content.setAttribute('contenteditable', 'false');
    const denotationChar = document.createElement('span');
    denotationChar.className = 'ql-mention-denotation-char';
    const label = document.createElement('span');
    label.className = 'bg-brand-tertiary-300 p-1 rounded';
    label.textContent = metric.name;
    content.append(denotationChar, label);
    mention.appendChild(content);

    const range = quillInstance.getSelection(true);
    if (range) {
        quillInstance.clipboard.dangerouslyPasteHTML(range.index, mention.outerHTML);
        quillInstance.setSelection(range.index + 2);

        const formula = getCustomFormula(quillInstance.root.innerHTML);
        window.Livewire.dispatch('addCustomFormulaInput', { formula: formula });
    }
}

export { initMentions as default, insertMetric };
